// extracted by extract-css-chunks-webpack-plugin
module.exports = {"tooltipZIndex":"3","tooltipSpacing":"10px","duration":"bWS-A-Ap6DAD"};